/** PR3.4 display choices mirror backend neoSpecialEarnings.js.
 * Metadata only; tax classifications never create automatic PAYE clearance.
 */
const pending={value:'pending',label:'Not yet classified — review required'};
const cash={value:'recurring-taxable-cash',label:'Regular taxable cash payment — reconciliation required'};
const annual={value:'annual-bonus',label:'Annual or irregular bonus — special PAYE review'};
const travel={value:'travel-allowance',label:'Travel allowance — special SARS rules'};
const expenses={value:'expense-reimbursement',label:'Expense reimbursement — verify expense records'};
const special={value:'other-special',label:'Other special earning — specialist review'};
export const SPECIAL_EARNING_CLASSIFICATIONS={
  allowance:[pending,cash,travel,special],
  bonus:[pending,annual,special],
  reimbursement:[pending,expenses,special],
  'other-earning':[pending,cash,annual,special]
};
